import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const TenantConcept = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 35 41"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="M28.06 40.7659H4.3857C4.36734 40.7659 4.349 40.7549 4.33798 40.7365C3.23318 38.8205 1.95587 36.6183 0.759304 34.5371C-0.0812263 33.08 -0.0812263 31.2815 0.759304 29.8243L17.5185 0.798452C17.5405 0.761748 17.5919 0.758077 17.614 0.798452C18.6894 2.65937 19.9704 4.87998 21.1596 6.94644C22.0001 8.39993 21.9965 10.1911 21.1596 11.6483L9.30776 32.1844H25.722C25.766 32.1844 25.7954 32.1367 25.7733 32.1L20.8696 23.6029H30.7431C30.7615 23.6029 30.7798 23.6139 30.7908 23.6323C31.8956 25.5445 33.1729 27.7578 34.3695 29.8353C35.2137 31.2961 35.21 33.091 34.3695 34.5518L32.1379 38.4131C31.2937 39.8703 29.7374 40.7695 28.0527 40.7695L28.06 40.7659Z" />
    </svg>
  );
};

TenantConcept.displayName = 'TenantConcept';
